module.exports = __webpack_public_path__ + "static/media/feature-2.b041a75c.png";